import { render, staticRenderFns } from "./intshopheader.vue?vue&type=template&id=08058306&scoped=true"
import script from "./intshopheader.vue?vue&type=script&lang=js"
export * from "./intshopheader.vue?vue&type=script&lang=js"
import style0 from "./intshopheader.vue?vue&type=style&index=0&id=08058306&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08058306",
  null
  
)

export default component.exports